import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store, persistor } from "./store/store"; // import persistor
import { PersistGate } from "redux-persist/integration/react"; // import PersistGate
import { SidebarContextProvider } from "./store/sidebarContext";
import { ThemeContextProvider } from "./store/themeContext";
import { LoginContextProvider } from "./store/loginContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <LoginContextProvider>
        <ThemeContextProvider>
          <SidebarContextProvider>
            <App />
          </SidebarContextProvider>
        </ThemeContextProvider>
      </LoginContextProvider>
    </PersistGate>
  </Provider>
);
